<template>
  <v-app fluid class="application">
    <Sidebar :drawer="showSidebar" v-if="hasChosenOrganisation && !brand.loading && !brand.error" :key="orgId" />
    <Navigation
      v-if="!brand.loading && !brand.error"
      @drawer="(val) => (showSidebar = val)"
      v-show="hasChosenOrganisation" />
    <v-main
      :class="{ login: !hasChosenOrganisation, loggedIn: hasChosenOrganisation }"
      style="transition: none !important">
      <v-container style="height: 100%" fluid>
        <div class="d-flex align-center justify-center" v-if="brand.loading && !brand.error">
          <v-overlay z-index="9999" opacity=".7" :value="brand.loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </div>
        <UnspecifiedError v-else-if="brand.error" />
        <div v-else>
          <v-alert v-if="isLoggedIn && isNewDashboardAvailable" text color="blue" class="mb-8">
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex">
                <v-icon class="me-3" color="blue">mdi-creation</v-icon>
                <div class="font-weight-medium">
                  Try our improved dashboard with streamlined workflows and a modern interface.
                </div>
              </div>
              <v-btn class="ms-4" color="blue" dark elevation="0" @click="switchDashboard">Switch dashboard</v-btn>
            </div>
          </v-alert>
          <router-view />
        </div>
      </v-container>
    </v-main>
    <Snackbar :config="snackbarConfig" />
  </v-app>
</template>

<script>
import Sidebar from "./components/Navigation/Sidebar";
import { mapActions, mapState } from "vuex";
import { ACTION_EDIT_SENDER_INFO } from "./store/constants/user";
import Snackbar from "./components/Common/Snackbar";
import { FETCH_BRAND } from "@/store/constants/brand";
import UnspecifiedError from "@/components/Common/UnspecifiedError.vue";

const Navigation = () => import("./components/Navigation/Navigation");

// noinspection JSUnusedGlobalSymbols
export default {
  name: "App",
  components: {
    UnspecifiedError,
    Snackbar,
    Sidebar,
    Navigation,
  },
  data() {
    return {
      showSidebar: true,
      isNewDashboardAvailable: false,
      snackbarConfig: {
        text: "Session expired",
        color: "error",
        snackbar: false,
      },
    };
  },
  methods: {
    ...mapActions({
      fetchBrand: FETCH_BRAND,
      setSenderData: ACTION_EDIT_SENDER_INFO,
    }),
    switchDashboard() {
      this.$posthog.updateEarlyAccessFeatureEnrollment("new-dashboard", true);
      this.$cookies.set("new-dashboard", true);
      window.location.replace("/overview");
    },
  },
  watch: {
    sessionExpiration() {
      this.snackbarConfig.text = "Session expired";
      this.snackbarConfig.snackbar = true;
    },
    rateLimited() {
      this.snackbarConfig.text = "Too many failed login attempts. Try again later";
      this.snackbarConfig.snackbar = true;
    },
  },
  computed: {
    ...mapState({
      brand: (state) => state.brand,
      hasChosenOrganisation: (state) => state.user.hasChosenOrganisation,
      isLoggedIn: (state) => state.user.isLoggedIn,
      sessionExpiration: (state) => state.user.sessionExpired,
      rateLimited: (state) => state.user.rateLimited,
      userId: (state) => state.user.userID,
      userEmail: (state) => state.user.email,
      userPermissions: (state) => state.user.permissions,
      orgId: (state) => state.user.organisationId,
    }),
  },
  mounted() {
    this.fetchBrand();

    if (this.$posthog.isFeatureEnabled("new-dashboard-available")) {
      this.isNewDashboardAvailable = true;
    }
  },
};
</script>
<style lang="scss">
body::-webkit-scrollbar {
  display: none !important;
}

@-moz-document url-prefix() {
  * {
    font-weight: 600 !important;
    scrollbar-width: none;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 4px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

#nav {
  z-index: 2000 !important;
  background: red;
}

#red {
  background: #000;
}

.login {
  padding: 0;
  background: #fff;
}

.loggedIn {
  background: #fafafa;
}

.pencil {
  cursor: pointer;

  i {
    pointer-events: none;
  }

  &:hover {
    i {
      color: #4caf50 !important;
      transform: scale(1.1);
    }
  }
}

.delete {
  @extend .pencil;

  &:hover {
    i {
      color: red !important;
      transform: scale(1.1);
    }
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus input:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
}

.v-switch-reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
</style>
